<template>
  <Print v-if="isPrint" :board="board" :form="form" :header="header" />
  <div v-else>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :readonly="board.readonly"
      :types="['writer_name', 'phone', 'date']"
      :typeslabel="{
        writer_name: '작성자',
        phone: '작성자 전화번호',
        date: '작성일',
      }"
    />

    <div>
      <h5 class="my-4"><i class="dot"></i> Ⅰ. 건설업체 개요</h5>
      <div class="writeGridContainer">
        <div>
          <div>①사업장명</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.field.field_name }}</p>
          <field-selector v-else :readonly="board.readonly" v-model="form.field.id" @select="handleFieldSelect" :use-default-field="false" />
        </div>
        <div>
          <div>②법인등록번호 (③사업자등록번호)</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.사업자등록번호 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.사업자등록번호" />
        </div>
        <div>
          <div>대표자</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.대표자 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.대표자" />
        </div>

        <div>
          <div>④사업장관리번호</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.사업장관리번호 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.사업장관리번호" />
        </div>
        <div>
          <div>소재지</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.소재지 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.소재지" />
        </div>
        <div>
          <div>시공능력평가순위</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.시공능력평가순위 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.시공능력평가순위" />
        </div>
        <div>
          <div>안전·보건 조직<br />구성 여부</div>
          <div class="radio">
            <vs-radio v-for="option in ['Y', 'N']" :key="`안전보건조직구성여부${option}`" v-model="form.안전보건조직구성여부" vs-name="안전보건조직구성여부" :vs-value="option">{{ option }}</vs-radio>
          </div>
        </div>
        <div>
          <div>안전·보건 조직<br />(팀·부서) 명</div>
          <ml-input :readonly="board.readonly" v-model="form.안전보건조직팀부서명" />
        </div>
      </div>
    </div>

    <table-custom
      :board="board"
      :is-print="isPrint"
      title="Ⅱ. ⑤본사 안전보건 전담 임·직원 현황"
      :tableData="[
        { id: 'no', title: '연번', type: 'no', width: '80px' },
        { id: '성명', title: '성명', type: 'text', placeholder: '내용' },
        { id: '생년월일', title: '생년월일', type: 'date', placeholder: 'YYYY-MM-DD' },
        { id: '직급', title: '직급(직위)', type: 'text', placeholder: '내용' },
        { id: '발령일', title: '현 부서 발령일<br/>(평가기간 내 근무일수)', headStyle: 'padding:4px 0', type: 'number', placeholder: '내용' },
        { id: '안전보건관련자격', title: '⑥안전·보건 관련 자격', type: 'text', placeholder: '내용' },
        { id: '임원여부', title: '임원(O/X)', type: 'radio', middle: true, radioItems: [{ value: 'O' }, { value: 'X' }] },
      ]"
      :mobile="['no', '현장명', '사업개시번호']"
      v-model="form.임직원현황"
      :separate-button-row="isMobile"
      class="mt-28px"
    >
      <template #customTr>
        <tr style="background: #f9f9f9 !important">
          <td></td>
          <td class="text-center py-3">합계</td>
          <td class="text-center py-3" colspan="3">본사 안전·보건 전담 임·직원 수 : {{ form.임직원현황.length }}명</td>
          <td class="text-center py-3" colspan="3">안전·보건관리자 자격보유자 : {{ qualifiedCount }}명</td>
        </tr>
      </template>
    </table-custom>

    <div class="mt-28px">
      <h5 class="my-4"><i class="dot"></i> 보고인</h5>
      <name-with-signature-row label-name="사업주" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />
      <table class="info mt-7">
        <colgroup>
          <col width="224" />
        </colgroup>
        <tr>
          <th>첨부서류</th>
          <td>
            <ul style="list-style: decimal; padding-left: 16px">
              <li>본사 조직도 및 업무분장표 1부.</li>
              <li>안전·보건 자격이 있는 자는 그 자격증의 사본 1부.</li>
              <li>건설기술인 경력증명서 1부.</li>
            </ul>
          </td>
        </tr>
      </table>
    </div>

    <div class="mt-28px">
      <h5 class="my-4"><i class="dot"></i> 참고</h5>
      <table class="info">
        <tr>
          <th>공지사항</th>
        </tr>
        <tr>
          <td>「건설업체의 산업재해예방활동 평가기준」 제13조의 규정에 따라 건설업체가 제출한 산업재해 예방활동 실적에 대한 공단의 확인 결과, 허위로 판정된 경우 해당 지표의 평가점수를 0점 처리함</td>
        </tr>
      </table>
      <table class="info">
        <tr>
          <th>작성방법</th>
        </tr>
        <tr>
          <td>
            ① 사업장명: 도급인 본사 사업장명을 적습니다.<br />
            ② 법인등록번호: 법인 설립 시 등기소에서 부여하는 등기용 등록번호를 적습니다.<br />
            ③ 사업자등록번호: 국세청에 등록된 도급인 사업장 사업자 등록번호를 적습니다.<br />
            ④ 사업장관리번호(사업개시번호): 근로복지공단의 산업재해보상보험 가입 시 부여된 도급인 사업장 관리번호(사업개시번호)를 적습니다.<br />
            ⑤ 본사 안전·보건 전담 임·직원 수: 건설업체의 본사에서 평가기간 중 6개월 초과 근무한 정규직 안전·보건 전담자의 성명 및 자격현황<br />
            ⑥ 안전·보건 관련 자격: 산업안전보건법 시행령 별표4(제8호는 제외)와 별표6에서 정한 안전·보건관리자 자격의 종류<br />
            ⑦ 임원: 본사에 안전·보건 조직이 있고, 그 조직 구성원이 상법상 임원인 경우<br />
          </td>
        </tr>
      </table>
    </div>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="mt-28px" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import RadioGroup from "@/components/radio/RadioGroup.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import Print from "./Print.vue";
import TimeSelectorRang from "@/components/selector/TimeSelectorRang.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";

export default {
  components: {
    FieldSelector,
    TimeSelectorRang,
    Print,
    TableCustom,
    TimeSelector,
    RadioGroup,
    FileUploadModule,
    FieldSelectModule,
    PhotoUploadGridModule,
    NameWithSignatureRow,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  async created() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkMobile);
  },
  data() {
    return {
      isMobile: false,
      showEmployeePopup: false,
      showMemberPopup: false,

      form: {
        stdInfo: {},
        photoList: [],
        fileList: [],

        field: {},
        사업자등록번호: "",
        대표자: "",
        사업장관리번호: "",
        소재지: "",
        시공능력평가순위: "",
        안전보건조직구성여부: "",
        안전보건조직팀부서명: "",

        임직원현황: [],
        sign1: {
          name: "",
          sign: "",
        },
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    qualifiedCount() {
      const arr = this.form.임직원현황.filter((item) => item.안전보건관련자격);
      return arr.length;
    },
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    },
    handleFieldSelect(field) {
      this.form.field = field;
      if (field && field.id) {
        this.loadField(field.id);
      }
    },
    async loadField(fieldId) {
      await this.$store.dispatch("project/LOAD_FIELD", { fieldId });
      const info = this.$store.state.project.fieldInfo;

      this.form.대표자 = info.director_name || "";
      this.form.소재지 = info.address || "";
    },
  },
};
</script>
<style scoped lang="scss">
table.info {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  margin-bottom: 14px;

  th {
    font-weight: 500;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0%;
    text-align: center;

    background-color: #f9f9f9;
  }
  td {
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    letter-spacing: 0%;
  }

  th,
  td {
    padding: 14px !important;
    border: solid 1px #cdcdcd;
  }
}
</style>
